<template>
	<v-app>
		<NavView>
		</NavView>
		<v-main>
			<v-card>
				<v-tabs v-model="activeTab">
					<v-tab @click="getUsers()">
						用户管理
					</v-tab>
					<v-tab @click="getRoles()">
						角色管理
					</v-tab>
				</v-tabs>

				<v-tabs-items v-model="activeTab">
					<v-tab-item>
						<v-card>
							<v-container>
								<v-row justify="center">
									<span style="margin:10px;"><v-btn @click="addUserDivShow=true;">添加</v-btn> <v-btn
											@click="delUser()">删除</v-btn><v-btn @click="editUser()">编辑用户</v-btn></span>
								</v-row>
							</v-container>

							<v-data-table :headers="userHeaders" :items="users" item-key="userId" :items-per-page="5"
								class="elevation-1" v-model="selectedUser" show-select></v-data-table>
						</v-card>
					</v-tab-item>
					<v-tab-item>
						<v-card>
							<v-container>
								<v-row justify="center">
									<span style="margin:10px;"><v-btn
											@click="delUserFromRoleDivShow()">从组中删除用户</v-btn></span>
									<span style="margin:10px;"><v-btn
											@click="addUserToRoleDivShow()">添加用户</v-btn></span>
								</v-row>
							</v-container>

							<v-data-table :headers="roleHeaders" :items="roles" item-key="roleId" :items-per-page="5"
								class="elevation-1" v-model="selectedRole" show-select></v-data-table>
						</v-card>
					</v-tab-item>
				</v-tabs-items>
			</v-card>
			<v-dialog v-model="roleDivShow" max-width="500px">
				<v-card>
					<v-card-title class="text-h5">管理员设置</v-card-title>
					<v-card-text>
						<v-checkbox label="系统管理员"></v-checkbox>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="blue-darken-1" variant="text" @click="saveRole">保存</v-btn>
						<v-btn color="blue-darken-1" variant="text" @click="roleDivShow=false;">关闭</v-btn>
						<v-spacer></v-spacer>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-dialog v-model="delUserFromRoleDiv" max-width="500px">
				<v-card>
					<v-card-title class="text-h5">{{selectedRoleName}}，删除用户</v-card-title>
					<v-card-text>
						<v-data-table v-model="selectedUsersDelFromRole" :headers="resultUsersHeaders"
							:items="resultRoleUsers" show-select item-key="id"></v-data-table>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="blue-darken-1" variant="text" @click="delUserFromRole()">删除用户</v-btn>
						<v-btn color="blue-darken-1" variant="text" @click="delUserFromRoleDiv=false;">关闭</v-btn>
						<v-spacer></v-spacer>
					</v-card-actions>
				</v-card>
			</v-dialog>



			<v-dialog v-model="addUserToRoleDiv" max-width="500px">
				<v-card>
					<v-card-title class="text-h5">{{selectedRoleName}}组添加用户</v-card-title>
					<v-card-text>
						<v-row>
							<v-col>
								<v-text-field type="search" v-model="searcheKey"></v-text-field>
							</v-col>
							<v-col><v-btn @click="searchUser">查找</v-btn></v-col>
						</v-row>
						<v-data-table v-model="selectedUsersAddToRole" :headers="resultUsersHeaders"
							:items="resultUsers" show-select item-key="id"></v-data-table>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="blue-darken-1" variant="text" @click="addUserToRole">保存</v-btn>
						<v-btn color="blue-darken-1" variant="text" @click="addUserToRoleDiv=false;">关闭</v-btn>
						<v-spacer></v-spacer>
					</v-card-actions>
				</v-card>
			</v-dialog>


			<v-dialog v-model="addUserDivShow" max-width="500px">
				<v-card>
					<v-card-title class="text-h5">添加用户</v-card-title>
					<v-card-text>
						<v-text-field type="text" v-model="newUser.name" label="姓名"></v-text-field>
						<v-text-field type="text" v-model="newUser.loginName" label="*登录名"
							:rules="[v => !!v || '用户名不能为空',v => v.length >= 4 || '用户名至少4个字符']"></v-text-field>
						<v-text-field type="text" v-model="newUser.password" label="*密码"
							:rules="[v => !!v || '密码不能为空',v => v.length >= 6 || '密码至少6个字符']"></v-text-field>
						<v-text-field type="text" v-model="newUser.tel"
							:rules="[v => !!v || '手机号不能为空',v => /^1[3-9]\d{9}$/.test(v) || '手机号格式不正确']"
							label="电话"></v-text-field>
						<v-text-field type="text" v-model="newUser.venderId" label="供应商代码"></v-text-field>
						<div style="color:chocolate;">{{addUserMsg}}</div>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn @click="addUser()">添加用户</v-btn>
						<v-btn color="blue-darken-1" variant="text" @click="addUserDivShow=false;">关闭</v-btn>
						<v-spacer></v-spacer>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-dialog v-model="msgDialog" max-width="500px">
				<v-card>
					<v-card-title class="text-h5">提示</v-card-title>
					<v-card-text>
						{{msg}}
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="blue-darken-1" variant="text" @click="msgDialog=false;msg=null;">关闭</v-btn>
						<v-spacer></v-spacer>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-dialog v-model="userEditDialogShow" max-width="500px">
				<v-card>
					<v-card-title class="text-h5">用户编辑</v-card-title>
					<v-card-text>
						<v-text-field type="text" v-model="user.name" label="姓名"></v-text-field>
						<v-text-field type="text" v-model="user.loginName" label="*登录名"
							:rules="[v => !!v || '用户名不能为空',v => v.length >= 4 || '用户名至少4个字符']"></v-text-field>
						<v-text-field type="text" v-model="user.tel"
							:rules="[v => !!v || '手机号不能为空',v => /^1[3-9]\d{9}$/.test(v) || '手机号格式不正确']"
							label="电话"></v-text-field>
						<v-text-field type="text" v-model="user.venderId" label="供应商代码"></v-text-field>
						<v-btn @click="resetPassword()">重置密码</v-btn>
						<div style="color: chocolate;">{{editUserMsg}}</div>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="blue-darken-1" variant="text"
							@click="userEditDialogShow=false;editUserMsg=null;">关闭</v-btn>
						<v-spacer></v-spacer>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-main>
	</v-app>
</template>

<script>
	import NavView from "./../components/NavBar";
	export default {
		name: 'indexView',
		components: {
			NavView,
		},
		data() {
			return {
				activeTab: 0,
				userHeaders: [{
						text: '序号',
						value: 'userId',
					}, {
						text: '登录名',
						value: 'loginName',
					},
					{
						text: '名字',
						value: 'name'
					}
				],
				roleHeaders: [{
					text: '组名',
					value: 'roleName',
				}],
				resultUsersHeaders: [{
						text: '登录名',
						value: 'loginName',
					},
					{
						text: '姓名',
						value: 'name',
					}
				],
				selected: [],
				msgDialog: false,
				msg: null,
				users: [],
				roleDivShow: false,
				usersRoles: null,
				selectedUser: [],
				addUserToRoleDiv: false,
				selectedRole: [],
				roles: [],
				searcheKey: null,
				resultUsers: [],
				selectedUsersAddToRole: [],
				selectedRoleName: null,
				delUserFromRoleDiv: false,
				selectedUsersDelFromRole: [],
				resultRoleUsers: [],
				addUserDivShow: false,
				newUser: {
					name: null,
					loginName: null,
					password: null,
					tel: null,
					venderId: null
				},
				addUserMsg: null,
				user: {
					name: null,
					loginName: null,
					tel: null,
					venderId: null
				},
				userEditDialogShow: false,
				editUserMsg: null
			}
		},
		created() {
			this.getUsers();
		},
		mounted() {

		},
		methods: {
			getUsers() {
				this.$axios.post(this.serverUrl + "/user/list", {}).then(res => {
					if (res.data.data != null) {
						this.users = res.data.data;
					}
				});
			},
			searchUser() {
				this.$axios.post(this.serverUrl + "/user/list", {
					loginName: this.searcheKey
				}).then(res => {
					if (res.data.data != null) {
						this.resultUsers = res.data.data;
					}
				});
			},
			showDetail() {
				if (this.selectedUser.length == 1) {
					this.$axios.post(this.serverUrl + "/user/details").then(res => {
						if (res.data.data != null) {
							this.user = res.data.data;
						}
					})
				} else {
					this.msgDialog = true;
					this.msg = "请选择一条记录";
				}
			},
			delUser() {

				if (this.selectedUser.length > 0) {
					let ids = [];
					this.selectedUser.forEach(item => {
						ids.push(item.id);
					})
					this.$axios.post(this.serverUrl + "/user/del", ids).then(res => {
						if (res.data.data != null) {
							this.getUsers();
						}
					})
				} else {
					this.msgDialog = true;
					this.msg = "请选择一条记录";
				}
			},
			addUserToRoleDivShow() {
				if (this.selectedRole.length === 1) {
					this.addUserToRoleDiv = true
					this.selectedRoleName = this.selectedRole[0].roleName;
				} else {
					this.msgDialog = true;
					this.msg = "请选择一个角色";
				}
			},
			delUserFromRoleDivShow() {
				if (this.selectedRole.length === 1) {
					this.delUserFromRoleDiv = true
					this.selectedRoleName = this.selectedRole[0].roleName;

					this.$axios.post(this.serverUrl + "/role/user/list", {
						roleId: this.selectedRole[0].roleId
					}).then(res => {
						if (res.data.state === 200) {
							this.resultRoleUsers = res.data.data;
						}
					});

				} else {
					this.msgDialog = true;
					this.msg = "请选择一个角色";
				}
			},
			addUserToRole() {
				if (this.selectedUsersAddToRole.length > 0) {
					let ids = new Array()
					this.selectedUsersAddToRole.forEach(item => {
						ids.push(item.id);
					})
					this.$axios.post(this.serverUrl + "/role/addUser", {
						roleId: this.selectedRole[0].roleId,
						userIds: ids
					}).then(res => {
						if (res.data.state === 200) {
							//this.roles = res.data.data;
							this.addUserToRoleDiv = false;
							this.selectedRole = [];
						}
					});
				} else {
					this.msgDialog = true;
					this.msg = "请选择一条记录";
				}
			},
			getUserRole() {
				if (this.selectedUser.length == 1) {
					this.$axios.post(this.serverUrl + "/user/getRoleByUId", {
						userId: this.selectedUser[0].id
					}).then(res => {
						if (res.data.data != null) {
							this.roles = res.data.data;
						}
					});
				} else {
					this.msgDialog = true;
					this.msg = "请选择一条记录";
				}
			},
			saveRole() {
				if (this.selectedUser.length == 1) {
					this.$axios.post(this.serverUrl + "/role/addUser", {
						userIds: this.selectedUser[0].id
					}).then(res => {
						if (res.data.data != null) {
							this.usersRoles = res.data.data;
						}
					});
				} else {
					this.msgDialog = true;
					this.msg = "请选择一条记录";
				}
			},
			getRoles() {
				this.$axios.post(this.serverUrl + "/role/list").then(res => {
					if (res.data.data != null) {
						this.roles = res.data.data;
					}
				});
			},
			delUserFromRole() {
				let userRole = [];
				this.selectedUsersDelFromRole.forEach(item => {
					userRole.push({
						userId: item.id,
						roleId: this.selectedRole[0].roleId
					})
				})
				this.$axios.post(this.serverUrl + "/role/user/del", userRole).then(res => {
					if (res.data.data != null) {
						this.roles = res.data.data;
					}
				});
			},
			async addUser() {
				let res = await this.$axios.post(this.serverUrl + "/user/add", this.newUser);
				if (res.data.state === 200) {
					this.getUsers();
					this.newUser.loginName = null;
					this.newUser.name = null;
					this.newUser.password = null;
					this.newUser.tel = null;
					this.newUser.venderId = null;
					this.addUserDivShow = false;
				} else {
					if (res.data.state == 500) {
						this.addUserMsg = "!" + res.data.msg;
					}
				}
			},
			editUser() {
				if (this.selectedUser.length == 1) {
					this.userEditDialogShow = true;
					this.user = this.selectedUser[0];
				} else {
					this.msgDialog = true;
					this.msg = "请选择一条记录";
				}
			},
			resetPassword() {
				this.$axios.post(this.serverUrl + "/user/resetPassword", this.user).then(res => {
					if (res.data.data != null && res.data.state == 200) {
						this.editUserMsg = this.user.loginName + "的密码已经重置为" + res.data.data;
					} else {
						this.editUserMsg = "重置密码失败，请联系系统管理员。";
					}
				});
			}
		}
	}
</script>

<style>
	.custom-list .v-list-item {
		list-style-type: disc;
		/* 圆点符号 */
		list-style-position: inside;
		/* 符号位置 */
	}
</style>